import { render, staticRenderFns } from "./versions.vue?vue&type=template&id=3f536bca&"
import script from "./versions.vue?vue&type=script&lang=js&"
export * from "./versions.vue?vue&type=script&lang=js&"
import style0 from "./versions.vue?vue&type=style&index=0&id=3f536bca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports